import { getBaseApi } from "../BaseApi";

export function getSupportCases(params: {
  skip?: number;
  limit?: number;
  status?: string;
  kind?: string;
  country?: string;
  sellerId?: string;
  search?: string;
}) {
  return getBaseApi().get("support-cases", params);
}

export function getSupportCase(id: string) {
  return getBaseApi().get(`support-cases/${id}`);
}

export function createSupportCase(body: {
  kind: "ticket" | "complaint";
  subject: string;
  body: string;
  country: string;
  relatedOrderId?: string;
  priority?: "low" | "normal" | "high";
}) {
  return getBaseApi().post("support-cases", body);
}

export function updateSupportCase(
  id: string,
  body: {
    status?: string;
    priority?: string;
    assignedTo?: string | null;
    adminResponse?: string;
    internalNote?: string;
  }
) {
  return getBaseApi().put(`support-cases/${id}`, body);
}
